namespace $ {

	export class $shm_hitalama_map_history_storage_target extends $giper_baza_entity.with({
		Writers: $shm_hitalama_map_history_storage_target_writers,
	}) {}

}
